var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-create main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitPrePaymentData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("prepayments.invoice_prepayment_processing"))),
          ]),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/funder/dashboard" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$t("general.home")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/funder/invoices" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _vm._v(
                _vm._s(_vm.$t("prepayments.invoice_prepayment_processing"))
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("SingleInvoiceRow", { attrs: { fetchData: _vm.fetchData } }),
        _vm._v(" "),
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("prepayments.invoice_prepayment_processing"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-actions header-button-container mr-4" },
            [
              _c(
                "base-button",
                {
                  attrs: {
                    loading: _vm.isLoading,
                    disabled: _vm.isLoading,
                    icon: "save",
                    color: "theme",
                    type: "submit",
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("prepayments.save_prepayment_processing")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-card card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("prepayments.invoice_prepayment_processing")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("base-text-area", {
                      on: {
                        input: function ($event) {
                          return _vm.$v.formData.processing.$touch()
                        },
                      },
                      model: {
                        value: _vm.formData.processing,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "processing", $$v)
                        },
                        expression: "formData.processing",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.processing.$error
                      ? _c("div", [
                          !_vm.$v.formData.processing.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.$t("validation.required"))),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("Attachment"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }